<app-first-day-hero [height]="20">
    <h2 i18n="first day dialog text@@first-day-dialog-text">Hi! It looks like this is your first time here!</h2>
    <button mat-flat-button color="accent" i18n="first day dialog btn text@@first-day-dialog-btn-text" (click)="onBtnClick()">Get started</button>
</app-first-day-hero>
